import { __awaiter } from "tslib";
import Vue from "vue";
import { ErrorWrapper } from "./util";
//BaseService es una función genérica que retorna una clase declarada localmente.
//La clase retornada no es genérica, por lo tanto sus propiedades y métodos estáticos
//tienen tipos concretos para T.
// eslint-disable-next-line
export function BaseService() {
    class BaseService {
        static get entity() {
            throw new Error("entity getter not defined");
        }
        static get responseName() {
            throw new Error("name getter not defined");
        }
        static get profile() {
            const profile = window.localStorage.getItem("perfil");
            return profile;
        }
        /**
         * The method used to perform an AJAX-request.
         *
         * @param {string}      requestType The request type.
         * @param {string}      url         The URL for the request.
         * @param {string|null} name        The name of the object response.
         * @param {Record<string, unknown> |null} data        The data to be send with the request.
         * @param {Object|null} config      The config object to be sent with the request.
         *
         * @returns {Promise} The result in a promise.
         */
        static submit(submitData) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const path = submitData.isFullPath ? submitData.path : `${this.getApiUrlEntity(localStorage.getItem("perfil"))}${this.entity}/${submitData.path}`;
                    const response = yield Vue.$http2[submitData.method](path, submitData.method == "get" ? submitData.config : submitData.data, submitData.config);
                    const responseName = submitData.responseName ? submitData.responseName : this.responseName;
                    let data;
                    data = response;
                    if (responseName && !submitData.showFullResponse) {
                        data = responseName ? response.data[responseName] : response.data;
                    }
                    if (submitData.config == null) {
                        return data;
                    }
                    else {
                        if (submitData.config.showResponseWrapper) {
                            return data;
                            // resolve(new ResponseWrapper(response, data));
                        }
                        else {
                            return data;
                        }
                    }
                }
                catch (error) {
                    if (error) {
                        // reject(new ErrorWrapper(error, ""));
                        throw new ErrorWrapper(error, "");
                        // reject(response);
                        // throw new ErrorWrapper(response)
                    }
                    else {
                        throw "Error";
                    }
                }
                /*
                return new Promise<Type>((resolve, reject) => {
                  const path = submitData.isFullPath ? submitData.path : `${this.entity}/${submitData.path}`;
                  Vue.$http[submitData.method](path, submitData.data, submitData.config)
                    .then((response: AxiosResponse) => {
                      const responseName = submitData.responseName ? submitData.responseName : this.responseName;
                      let data;
                      if (responseName) {
                        data = responseName ? response.data[responseName] : response.data;
                        console.log(data);
                      }
                      if (submitData.config == null) {
                        resolve(data);
                      } else {
                        if (submitData.config.showResponseWrapper) {
                          resolve(data);
                          // resolve(new ResponseWrapper(response, data));
                        } else {
                          resolve(data);
                        }
                      }
                    })
                    .catch(({ response }: AxiosError) => {
                      if (response) {
                        reject(new ErrorWrapper(response, ""));
                        // reject(response);
                        // throw new ErrorWrapper(response)
                      } else {
                        reject();
                      }
                    });
                });
                */
            });
        }
        /**
         * ------------------------------
         * @HELPERS
         * ------------------------------
         */
        // static responseWrapper(...rest: any[]) {
        // 	return new ResponseWrapper(...rest)
        // }
        // static errorWrapper(...rest: any[]) {
        // 	return new ErrorWrapper(...rest)
        // }
        /**
         * ----------------------------
         * BASIC API CALLS
         * ----------------------------
         */
        static getAll() {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "get",
                    path: `${this.getApiUrlEntity(localStorage.getItem("perfil"))}${this.entity}`,
                    isFullPath: true,
                });
            });
        }
        static getById(id) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "get",
                    path: `${id}`,
                });
            });
        }
        static create(data, config = {}) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "post",
                    path: `${this.getApiUrlEntity(localStorage.getItem("perfil"))}${this.entity}`,
                    data: data,
                    config: config,
                    isFullPath: true,
                });
            });
        }
        static update(id, data) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "put",
                    path: `${id}`,
                    data: data,
                });
            });
        }
        static remove(id) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "delete",
                    path: `${id}`,
                });
            });
        }
        static getTrash() {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "get",
                    path: `trash`,
                });
            });
        }
        static restore(id) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.submit({
                    method: "delete",
                    path: `activate/${id}`,
                });
            });
        }
        static getApiUrlEntity(entity) {
            if (process.env.VUE_APP_SHOW_ENTITY === "true") {
                return `${entity}/`;
            }
            return "";
        }
    }
    return BaseService;
}
